module.exports = __webpack_public_path__ + "static/media/external-link-square.1796cc7a.svg";